import { Link, usePage } from '@inertiajs/react'
import {
  CalendarDays,
  CheckSquare,
  LayoutGrid,
  Clock,
  Home,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import * as Routes from '@/lib/routes'

// ナビゲーション項目
// タイムゾーンはサーバー側で管理されるため、today パラメータは不要
const navItems = [
  { href: Routes.root_path(), icon: Home, label: 'ホーム' },
  { href: Routes.habits_path(), icon: CheckSquare, label: '今日' },
  { href: Routes.weekly_habits_path(), icon: LayoutGrid, label: '週間' },
  { href: Routes.monthly_habits_path(), icon: CalendarDays, label: '月間' },
  { href: Routes.timeline_habits_path(), icon: Clock, label: '30日' },
]

export function BottomNav() {
  const { url } = usePage()
  const urlPath = url.split('?')[0]

  return (
    <nav className="bottom-nav sm:hidden">
      <div className="flex w-full items-center">
        {navItems.map(({ href, icon: Icon, label }) => {
          const isActive = urlPath === href
          return (
            <Link
              key={href}
              href={href}
              className={cn('bottom-nav-item', isActive && 'active')}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span className="mt-1 truncate text-xs">{label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
